import {atom} from 'jotai'
import {ListFilter, TransactionItemList} from '../domain'

const list: TransactionItemList = {
  dataList: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 1,
    pageSize: 1,
    totalCount: 1,
  },
}

export const listAtom = atom<TransactionItemList>(list)
export const listFilterAtom = atom<ListFilter>({
  filterList: [],
  orderList: [{type: 2, key: 'Date'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
  search: {
    value: '',
    keyList: [],
  },
})
